import { DateTime } from 'luxon';

export const getOrdinalSuffix = (day: number) => {
  const j = day % 10,
    k = day % 100;
  if (j == 1 && k != 11) {
    return 'st';
  }
  if (j == 2 && k != 12) {
    return 'nd';
  }
  if (j == 3 && k != 13) {
    return 'rd';
  }
  return 'th';
};

export const formatDateWithOrdinal = (date: DateTime) => {
  const day = date.day;
  const suffix = getOrdinalSuffix(day);
  return date.toFormat(`MMM d'${suffix}', yyyy`);
};

export const getFromToStrings = (from: DateTime | null, to: DateTime | null): string => {
  const actualFrom = from;
  let actualFromStr = '';

  let actualTo = to;
  let actualToStr = '';
  // If no from, then set it to just before
  if (actualFrom != null) {
    actualFromStr = formatDateWithOrdinal(actualFrom);
  } else {
    actualFromStr = 'Before ';
  }

  // If no to, then set it to just end of day
  if (actualTo == null) {
    actualTo = DateTime.now().endOf('day');
    actualToStr = 'Today';
  } else {
    actualToStr = formatDateWithOrdinal(actualTo);
  }

  if (actualFrom == null && actualToStr == 'Today') {
    return 'Before Today';
  }

  const dateStr = actualFromStr + (actualFromStr == '' || actualFromStr === 'Before ' ? '' : ' - ') + actualToStr;

  return dateStr;
};
